module.exports = __webpack_public_path__ + "img/logo_top_account_index.9e9251f5.png";